<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card class="mb-0">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title> Nuevo Profesor </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mt-3">
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="apellido"
                prepend-icon="mdi-account"
                label="Apellidos *"
                maxlength="50"
                :rules="requiredRules"
                dense
                required
                @blur="upper"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="nombre"
                prepend-icon="mdi-account"
                label="Nombres *"
                maxlength="50"
                :rules="requiredRules"
                dense
                required
                @blur="upperNombres"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <v-text-field
                v-model="celular"
                prepend-icon="mdi-cellphone"
                label="Celular"
                maxlength="15"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="guardarProfesor"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";

export default {
  data: (vm) => ({
    nombre: null,
    apellido: null,
    celular: null,
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
  }),

  props: ["visible"],

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    guardarProfesor() {
      this.$swal({
        title: "Guardar profesor",
        text: "¿Desea registrar el profesor?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosProfesor = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            nombre: this.nombre,
            apellido: this.apellido,
            celular: this.celular,
          };
          let self = this;
          axios
            .post("/Profesional/GuardarProfesor", datosProfesor)
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "error",
                  title: "Ya existe un profesor registrado con ese nombre.",
                  vm: self,
                });
              } else {
                self.$refs.form.resetValidation();
                self.vaciarModels();

                document.getElementsByClassName(
                  "v-dialog--active",
                )[0].scrollTop = 0;
                self.showAlert({
                  icon: "success",
                  title: "Profesor registrado exitosamente.",
                  vm: self,
                  timer: 2000,
                });
                self.$emit("profesorRegistrado");
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El profesor no pudo ser registrado.",
                vm: this,
                timer: 2000,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    vaciarModels() {
      this.nombre = "";
      this.apellido = "";
      this.celular = "";
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    upper() {
      if (this.apellido != null)
        this.apellido = this.apellido.toString().toUpperCase();
    },
    upperNombres() {
      if (this.nombre != null)
        this.nombre = this.nombre.toString().toUpperCase();
    },
  },

  created() {
    this.vaciarModels();
  },
};
</script>
